import Sidebar from "./sidebar";
import ApiEditor from "./apieditor";
import Webhooks from "./webhooks";
import { useState } from "react";

export default function Connections() {
  const [api, setApi] = useState(null);
  const [webhook, setWebhook] = useState(null);
  const [toggle, setToggle] = useState("api");
  return (
    <div style={{ display: "flex" }} className="page">
      <Sidebar
        toggle={{ value: toggle, set: setToggle }}
        api={{ value: api, set: setApi }}
        webhook={{ value: webhook, set: setWebhook }}
      />
      {api && toggle === "api" && <ApiEditor api={api} setApi={setApi} />}
      {webhook && toggle === "webhook" && (
        <Webhooks webhook={webhook} setHook={setWebhook} />
      )}
    </div>
  );
}
